import {  EntityType } from '@lib/deals';
import { QPAddFormEntity } from '../types';

export function toForm(
  {
   
    buyers,
    associated_person,
   statement_date,
   statement,
   statement_type,
   source_urls,
   designation,
   source,
    ...deal
  }: QPAddFormEntity,
  appendEmpty = true
) {
  // const source_urls_temp = source_urls ? source_urls.split(',').map(eachAka => eachAka.trim()) : [];
 const source_urls_temp = source_urls
   ? source_urls
       .split(',')
       .map(eachUrl => eachUrl.trim())
       .filter(Boolean)
	   : [];
  return {
    ...deal,
    buyers:
      buyers && buyers.length > 0
        ? buyers
        : appendEmpty
        ? [
            {
              vtr_id: '',
              type: EntityType.company,
              name: '',
              meta: null,
              relation_type: 'buyer',
              order_id: 1,
            },
          ]
        : [],
    associated_person:
    associated_person && associated_person.length > 0
      ? associated_person
      : appendEmpty
      ? [
          {
            vtr_id: '',
            person_vtr_id: '',
            type: 'PERSON',
            name: '',
            meta: null,
            relation_type: 'person',
            order_id: 1,
          },
        ]
      : [],
  
    statement_date: statement_date ? statement_date : null,
    statement_type: statement_type ? statement_type : null,
    designation: designation ? designation : null,
    statement: statement ? statement : "",
    source_urls: source_urls_temp as unknown as string,
    source: source ? source : null,
    };
}

export function fromForm({
  buyers,
  associated_person,
  ...deal
}): QPAddFormEntity {
  // Assign entitiy values
  deal.buyers = buyers
    .filter(e => e)
    .filter(e => e.name)
    .map((e, idx) => (delete e['meta'], e));
  if (associated_person) {
    deal.associated_person = setAssociatedPersonName(associated_person);
  }else {
    deal.associated_person = []
  }
 //console.log(deal, 'deal');
  return deal as QPAddFormEntity;
}


function setAssociatedPersonName(associated_person) {
  let requiredAssociatedPerson = [];
  if (associated_person) {
    requiredAssociatedPerson = associated_person.map(x => {
      if (typeof x === 'string') {
        return {
          name: x,
          vtr_id: '',
          designation: '',
          company: '',
          company_vtr_id: '',
          relation_type:'',
          type:'',
          order_id: 1,
          person_vtr_id:''
        };
      } 
      else if(x.meta){
        return {
          name: x?.name,
          vtr_id: x?.vtr_id,
          designation: x?.meta?.selectedCompany?.designation ? x?.meta?.selectedCompany?.designation : "",
          company: x?.meta?.selectedCompany?.company_vtr_id,
          company_vtr_id: x?.meta?.selectedCompany?.company_vtr_id,
          company_name: x?.meta?.selectedCompany?.company_name === "No Company" ? x?.meta?.selectedCompany?.company_name : "",
          relation_type:'person',
          type:'PERSON',
          order_id: 1,
          person_vtr_id: x?.meta?.selectedCompany?.person_vtr_id,
        };
      }
      else {
        return {
          name: x.name,
          vtr_id: x.vtr_id,
          designation: x.designation ? x.designation : "",
          company: x.company,
          company_vtr_id: x.company,
          company_name: x.company_name === "No Company" ? "" : x.company_name,
          relation_type:'person',
          type:'PERSON',
          order_id: 1,
          person_vtr_id: x.person_vtr_id,
          
        };
      }
    });
  }
  return requiredAssociatedPerson.filter((person) => person !== null);
}
